import { FaShoppingBag, FaSmile, FaBriefcase, FaUsers } from 'react-icons/fa';

const counter = [
  {
    id: 1,
    icon: <FaShoppingBag />, // Shopping bag icon
    title: 'Delivered Products',
    count: '50',
  },
  {
    id: 2,
    icon: <FaSmile />, // Smiling face icon
    title: 'Satisfied Clients',
    count: '500',
  },
  {
    id: 3,
    icon: <FaBriefcase />, // Briefcase icon
    title: 'Projects Completed',
    count: '300',
  },
  {
    id: 4,
    icon: <FaUsers />, // Users icon
    title: 'Professional Experts',
    count: '20',
  },
];

export default counter;